import {Trans} from '@lingui/macro';
import React, {FC, useCallback} from 'react';

import {ContactsManagerUpdateCardGroupPropertiesEnum} from '../../../../libs/contacts-manager/src/lib/ui/web/helpers/trackingHelpers';
import {Handler, HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {globalNamespace} from '../../../helpers/models/namespaceHelpers';
import {CardGroupModel} from '../../../models/api/cardGroupModel';
import {InterfaceEventsEnum, trackInterfaceEvent} from '../../../services/tracking';
import {EditCardGroupOptions} from '../../../store/data/cardGroups/cardGroupsActions';
import {CardGroupPopover} from './cardGroupPopover';

/*
 * Constants.
 */

const dropdownWidth = 300;

/*
 * Props.
 */

interface EditCardGroupPopoverProps {
  popoverProps: PopoverTransferProps;
  userNamespace?: string;
  cardGroup: CardGroupModel;
  editCardGroupAsync: HandlerOf<EditCardGroupOptions>;
  onClose: Handler;
  onDelete: Handler;
}

/*
 * Component.
 */

export const EditCardGroupPopover: FC<EditCardGroupPopoverProps> = ({
  popoverProps,
  userNamespace = globalNamespace,
  cardGroup,
  onDelete,
  editCardGroupAsync,
  onClose,
}) => {
  const onSave = useCallback(
    async ({name}) => {
      await editCardGroupAsync({cardGroupId: cardGroup.id, name});
      trackInterfaceEvent(InterfaceEventsEnum.CONTACTS_MANAGER_CARD_GROUP_UPDATE, {
        namespace: cardGroup.namespace,
        update_type: ContactsManagerUpdateCardGroupPropertiesEnum.NAME,
      });
      onClose();
    },
    [cardGroup, onClose, editCardGroupAsync],
  );

  return (
    <CardGroupPopover
      popoverProps={popoverProps}
      userNamespace={userNamespace}
      cardGroup={cardGroup}
      defaultNamespace={cardGroup.namespace}
      dropdownWidth={dropdownWidth}
      onClose={onClose}
      onConfirm={onSave}
      onDelete={onDelete}
      namespaceDisplayMessage={renderNamespaceDisplayMessage()}
    />
  );
};

/*
 * Helpers.
 */

function renderNamespaceDisplayMessage() {
  return (
    <Trans id="contact-list-dropdown-group-access-message">Cannot edit access after list is created</Trans>
  );
}
